import V3Check from './V3Check'
import { CheckUtils } from 'utils'

export default class V3BlogBacklinksCheck extends React.Component {
  constructor(props) {
    super(props)

    this.renderInfo = this.renderInfo.bind(this)
    this.renderDetails = this.renderDetails.bind(this)
  }

  render() {
    const props = {
      ...this.props,
      info: this.renderInfo,
      details: this.renderDetails
    }

    return <V3Check { ...props } />
  }

  renderDetails() {
    return CheckUtils.renderDetailsList(this.props.check.checkItems)
  }

  renderInfo() {
    return (
      <div>
        <h2>Key points</h2>
        <p>
          Search engines follow links to discover new pages to index. They also use links to identify how important a page is.   
        </p>
        <p>
          Your blog post should lead readers to take another action on your site. Often it's linking to one of your product or services pages they might want to buy, or highlighting other useful content elsewhere on your site.
        </p>
        <hr />
        <h2>How it's used</h2>
        <ul>
          <li>Used by search engines to find pages to index</li>
          <li>The link text associates keywords with the target page</li>
        </ul>
        <hr />
        <h2>Best practice</h2>
        <ul>
          <li>Link to yourself extensively</li>
          <li>...but don't worry excessively about linking to other sites you don't control as doing so can look unnatural to search engines</li>
          <li>Use link text like 'shop for handmade wooden toys' rather than 'click here to shop'</li>
        </ul>
        <hr />
        <h2>Fix this yourself</h2>
        <p>
          Aim to include at least three links to your primary website. For example, blog.example.com should link frequently to the primary domain of example.com.
        </p>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/v3_checks/V3BlogBacklinksCheck.js